import { render } from "./WholeSale.vue?vue&type=template&id=f8b9f2de&scoped=true"
import script from "./WholeSale.vue?vue&type=script&lang=js"
export * from "./WholeSale.vue?vue&type=script&lang=js"

import "./WholeSale.vue?vue&type=style&index=0&id=f8b9f2de&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8b9f2de"]])

export default __exports__